import _ from 'underscore';

export function getQuickInstrumentation({
  instrumentationSettings,
  constants,
  instrumentation,
}) {
  const localScenarioMap = {
    LoadOverviewPage: {
      scenario: instrumentationSettings.SCENARIONAME.LoadOverviewPage,
      activity: instrumentationSettings.ACTIVITYNAME.LoadOverviewPage,
    },
    QualifiedVisitOverviewPageFromCampaign: {
      scenario: instrumentationSettings.SCENARIONAME.QualifiedVisitOverviewPageFromCampaign,
      activity: instrumentationSettings.ACTIVITYNAME.QualifiedVisitOverviewPageFromCampaign,
    },
    SetOverviewPageAsDefault: {
      scenario: instrumentationSettings.SCENARIONAME.SetOverviewPageAsDefault,
      activity: instrumentationSettings.ACTIVITYNAME.SetOverviewPageAsDefault,
    },
    AddTileToOverview: {
      scenario: instrumentationSettings.SCENARIONAME.AddTileToOverview,
      activity: instrumentationSettings.ACTIVITYNAME.AddTileToOverview,
    },
    AddTileToOverviewFromPanel: {
      scenario: instrumentationSettings.SCENARIONAME.AddTileToOverviewFromPanel,
      activity: instrumentationSettings.ACTIVITYNAME.AddTileToOverviewFromPanel,
    },
    RemoveTileFromOverview: {
      scenario: instrumentationSettings.SCENARIONAME.RemoveTileFromOverview,
      activity: instrumentationSettings.ACTIVITYNAME.RemoveTileFromOverview,
    },
    ReorderTile: {
      scenario: instrumentationSettings.SCENARIONAME.ReorderTile,
      activity: instrumentationSettings.ACTIVITYNAME.ReorderTile,
    },
    ResizeTile: {
      scenario: instrumentationSettings.SCENARIONAME.ResizeTile,
      activity: instrumentationSettings.ACTIVITYNAME.ResizeTile,
    },
    FirstUse: {
      scenario: instrumentationSettings.SCENARIONAME.FirstUse,
      activity: instrumentationSettings.ACTIVITYNAME.FirstUse,
    },
    RemoveRetiredTilesFromOverview: {
      scenario: instrumentationSettings.SCENARIONAME.RemoveRetiredTilesFromOverview,
      activity: instrumentationSettings.ACTIVITYNAME.RemoveRetiredTilesFromOverview,
    },
    AddNewTilesToOverview: {
      scenario: instrumentationSettings.SCENARIONAME.AddNewTilesToOverview,
      activity: instrumentationSettings.ACTIVITYNAME.AddNewTilesToOverview,
    },
    OverviewPageLoadData: {
      scenario: instrumentationSettings.SCENARIONAME.OverviewPageLoadData,
      activity: instrumentationSettings.ACTIVITYNAME.OverviewPageLoadData,
    },
  };

  return function quickInstrumentation(name, msgs = []) {
    instrumentation.startScenario(localScenarioMap[name].scenario);
    instrumentation.startActivity(localScenarioMap[name].activity);
    if (_.isArray(msgs)) {
      if (_.size(msgs) > 0) {
        _.each(msgs, msg => instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'overview', msg));
      }
    } else if (msgs) {
      instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'overview', msgs);
    }
  };
}
